import { useState } from "react";
import { Loader2, Share2, Users, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { refreshRed } from "@/lib/red";

const Candidates = ({ s, value, onChange }) => (
  <div className="space-y-1.5" data-testid="owner-candidates">
    <p className="text-xs c-text-2">{s.candidatos.length > 1 ? "Tus contactos que coinciden: elige uno" : "Tu contacto que coincide"}</p>
    {s.candidatos.map((c) => (
      <label key={c.id} data-testid="owner-candidate" className={`flex items-start gap-2.5 p-2.5 rounded-xl border cursor-pointer ${value === c.id ? "border-[#bc9538] bg-[#bc9538]/10" : "c-line"}`}>
        <input type="radio" name="cand" checked={value === c.id} onChange={() => onChange(c.id)} className="mt-1 accent-[#bc9538]" />
        <span className="text-sm"><span className="font-semibold">{c.nombre}</span><span className="block text-xs c-text-2">{[c.puesto, c.empresa, c.ciudad].filter(Boolean).join(" · ")}{!c.tiene_telefono && " · sin teléfono"}</span></span>
      </label>
    ))}
  </div>
);

export const OwnerActions = ({ s, onChange }) => {
  const [cid, setCid] = useState(s.contact_id || s.candidatos[0]?.id || "");
  const [busy, setBusy] = useState(null);
  const [rejecting, setRejecting] = useState(false);
  const [motivo, setMotivo] = useState("");
  const act = async (action, body, msg) => {
    setBusy(action);
    try { onChange((await api.post(`/red/solicitudes/${s.id}/${action}`, body)).data); toast.success(msg); refreshRed(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  const spin = (k) => busy === k && <Loader2 className="w-4 h-4 animate-spin" />;
  if (s.estado === "aceptada") return (
    <button data-testid="owner-present-btn" disabled={!!busy} onClick={() => act("presentar", { contact_id: s.contact_id }, "Presentación lista")} className="w-full py-2.5 rounded-xl border c-line flex items-center justify-center gap-2 text-sm font-semibold">{spin("presentar") || <Users className="w-4 h-4" />} También hacer la presentación por WhatsApp</button>
  );
  return (
    <div data-testid="owner-actions" className="c-card p-4 space-y-3">
      <Candidates s={s} value={cid} onChange={setCid} />
      <button data-testid="owner-share-btn" disabled={!cid || !!busy} onClick={() => act("compartir", { contact_id: cid }, "Datos compartidos")} className="c-btn-primary w-full py-2.5 flex items-center justify-center gap-2">{spin("compartir") || <Share2 className="w-4 h-4" />} Compartir datos</button>
      <button data-testid="owner-present-btn" disabled={!cid || !!busy} onClick={() => act("presentar", { contact_id: cid }, "Presentación lista")} className="w-full py-2.5 rounded-xl border border-[#bc9538] c-accent flex items-center justify-center gap-2 font-semibold">{spin("presentar") || <Users className="w-4 h-4" />} Hacer la presentación</button>
      {rejecting ? (
        <div className="space-y-2">
          <input data-testid="owner-reject-reason" className="c-input text-sm" placeholder="Motivo (opcional, solo lo ves tú)" value={motivo} onChange={(e) => setMotivo(e.target.value)} />
          <button data-testid="owner-reject-confirm" disabled={!!busy} onClick={() => act("rechazar", { motivo }, "Solicitud rechazada")} className="w-full py-2.5 rounded-xl border border-red-500/50 text-red-600 flex items-center justify-center gap-2 text-sm font-semibold">{spin("rechazar")} Confirmar rechazo</button>
        </div>
      ) : (
        <button data-testid="owner-reject-btn" onClick={() => setRejecting(true)} className="w-full py-2 text-sm c-muted flex items-center justify-center gap-1.5"><X className="w-4 h-4" /> Rechazar</button>
      )}
    </div>
  );
};
